import { MenuItem, TextField, Button, FormControl, InputLabel, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./tranches.module.css";
// import { fixDateHandler } from "../ViewLoanDetails/ViewLoanDetails";

const TrancheDock = ({
  amount,
  prinAmount,
  releaseDate,
  setTrancheNumber,
  currentTrancheArray,
  setTrancheArray,
  currentTrancheNumber,
  edit,
  partlyDisbursed,
  chargeAmt,
  chargeName,
  isDisbursed
}) => {
  
  const fixTrancheDateHandler = (dateField) => {
    if (!dateField) {
      return "N/A";
    }
    const apiDate = dateField.split("T")[0];
    const formattedDate = apiDate.split("-");
    // console.log(formattedDate)
    return `${formattedDate[0]}-${formattedDate[1]}-${formattedDate[2]}`;
  };

  const [chargesIndices, setChargesIndices] = useState([]);
  const [numberOfTranche, setNumberOfTranche] = useState(1);
  const [trancheData, setTrancheData] = useState([
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
    {
      trancheAmount: "",
      tranchePrinAmount: "",
      trancheReleaseDate: "",
      isDisbursed: false,
      utr: "",
      trancheChargeName: "",
      trancheChargeAmt: ""
    },
  ]);

  useEffect(() => {
    if (edit) {
      setNumberOfTranche(currentTrancheNumber);
    }
  }, [edit, currentTrancheNumber]);

  useEffect(() => {
    if (edit && currentTrancheArray?.length > 0) {
      setTrancheData((prevData) =>
        prevData.map((tranche, index) => ({
          ...tranche,
          ...(currentTrancheArray[index] || {}),
        }))
      );
    }
  }, [edit, currentTrancheArray]);

  useEffect(() => {
    if (numberOfTranche === 1) {
      console.log(numberOfTranche)
      setTrancheData((prevState) => {
        let newData = [...prevState];
        newData[0].trancheAmount = amount;
        newData[0].tranchePrinAmount = prinAmount;
        newData[0].trancheReleaseDate = releaseDate;
        newData[0].trancheChargeAmt = chargeAmt;
        newData[0].trancheChargeName = chargeName;
        return newData;
      });
    }
    // eslint-disable-next-line
  }, [releaseDate, numberOfTranche, amount, chargeAmt, chargeName]);

  useEffect(() => {
    // setTrancheArray(trancheData);
    const updatedTrancheData = trancheData.map((tranche, index) => ({
      ...tranche,
      trancheNumber: index + 1
    }));
    console.log(updatedTrancheData)
    setTrancheArray(updatedTrancheData);
    // eslint-disable-next-line
  }, [trancheData]);

  const handleTrancheData = (type, value, index) => {
    console.log(type, value, index);
    const newTranche = [...trancheData];
    newTranche[index][type] = value;
    setTrancheData(newTranche);
  };

  const handleTrancheNumber = (value) => {
    setNumberOfTranche(value);
    setTrancheNumber(value);
    setTrancheArray(trancheData);
  };

  const handleAddCharges = (index) => {
    if (!chargesIndices.includes(index)) {
      setChargesIndices([...chargesIndices, index]);
    }
  };

  return (
    <div>
      <div className="input-item">
        <label>Please Select the Number of Tranche</label>
        <br />
        <br />
        <TextField
          className="input-field-add-loan"
          select
          name="number-of-tranche"
          variant="outlined"
          disabled={partlyDisbursed || isDisbursed}
          value={numberOfTranche}
          size="small"
          onChange={(e) => handleTrancheNumber(e.target.value)}
        >
          {[...Array(8).keys()].map((number) => {
            return (
              <MenuItem key={number} value={number + 1}>
                {number + 1}
              </MenuItem>
            );
          })}
        </TextField>
      </div>

      <div className={styles.tranches}>
        {trancheData.slice(0, numberOfTranche).map((tranche, index) => {
          return (
            <div
              key={index}
              // style={{ display: "flex", alignItems: "center", marginTop: "1rem", gap: "1rem"}}
              className={styles.trancheRow}
            >
              <div className={styles.fixedInputs}>

                {/* <label style={{ margin: "1rem", width: "6vw" }}> */}
                <label className={styles.trancheLabel}>
                  Tranche {index + 1} :
                </label>

                <TextField
                  size="small"
                  type="number"
                  variant="outlined"
                  value={numberOfTranche === 1 ? amount : tranche.trancheAmount}
                  disabled={tranche.isDisbursed || (numberOfTranche === 1 && index === 0) || isDisbursed}
                  onChange={(e) => handleTrancheData("trancheAmount", e.target.value, index)}
                  style={(index === 0 ? { backgroundColor: "rgb(216,216,216" } : null, { width: "10vw" })}
                  name="tranche-1"
                  label="Disbursement Amount"
                ></TextField>

                <TextField
                  size="small"
                  type="number"
                  onChange={(e) => handleTrancheData("tranchePrinAmount", e.target.value, index)}
                  variant="outlined"
                  value={numberOfTranche === 1 ? prinAmount : tranche.tranchePrinAmount}
                  disabled={tranche.isDisbursed || (numberOfTranche === 1 && index === 0) || isDisbursed}
                  style={(index === 0 ? { backgroundColor: "rgb(216,216,216" } : null, { width: "10vw" })}
                  name="tranche-1"
                  label="Principal Amount"
                ></TextField>


                <TextField
                  size="small"
                  variant="outlined"
                  onChange={(e) => handleTrancheData("trancheReleaseDate", e.target.value, index)}
                  disabled={tranche.isDisbursed || (numberOfTranche === 1 && index === 0) || isDisbursed}
                  style={(index === 0 ? { backgroundColor: "rgb(216,216,216" } : null, { width: "10vw" })}
                  value={numberOfTranche === 1 ? releaseDate : fixTrancheDateHandler(tranche.trancheReleaseDate)}
                  type="date"
                  label="Tranche Release Date"
                  inputProps={{
                        max: new Date().toISOString().split("T")[0],
                  }}
                ></TextField>

              </div>

              <div className={styles.chargeSection}>

                {!chargesIndices.includes(index) && !tranche.trancheChargeName && !tranche.trancheChargeAmt && (
                  <Button onClick={() => handleAddCharges(index)}
                    disabled={tranche.isDisbursed || (numberOfTranche === 1 && index === 0) || isDisbursed}
                  >Add Charges</Button>
                )}

                {(chargesIndices.includes(index) || tranche.trancheChargeName || tranche.trancheChargeAmt) && (
                  <>
                    <FormControl size="small" variant="outlined" style={{ minWidth: 150 }}>
                      <InputLabel>Charge Description</InputLabel>
                      <Select
                        value={tranche.trancheChargeName || ""}
                        onChange={(e) => handleTrancheData("trancheChargeName", e.target.value, index)}
                        disabled={tranche.isDisbursed || (numberOfTranche === 1 && index === 0) || isDisbursed}
                        label="Charge Description"
                      >
                        <MenuItem value="Legal">Legal</MenuItem>
                        <MenuItem value="Technical">Technical</MenuItem>
                        <MenuItem value="L&T">Both L&T</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      size="small"
                      type="number"
                      variant="outlined"
                      name="tranche-1"
                      onChange={(e) => handleTrancheData("trancheChargeAmt", parseInt(e.target.value), index)}
                      value={numberOfTranche === 1 ? chargeAmt : tranche.trancheChargeAmt}
                      disabled={tranche.isDisbursed || (numberOfTranche === 1 && index === 0) || isDisbursed}
                      style={{ width: "8vw" }}
                      label="Charge Amount"
                    ></TextField>
                  </>
                )}

              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrancheDock;
